import React from "react";
import { Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Breadcrumb } from "react-bootstrap";

const BreadCrumb = ({ items }) => {
  return (
<Breadcrumb
  className=" px-3 py-2 rounded-3 mb-4 d-flex align-items-center"
  style={{ whiteSpace: "nowrap" }}
>
  {items?.map((item, index) => (
    <Breadcrumb.Item
      key={index}
      active={item.active}
      linkAs={item.active ? "span" : Link}
      linkProps={item.active ? {} : { to: item.link }}
      className={`fw-semibold ${
        item.active ? "text-secondary" : "text-primary"
      } d-flex align-items-center`}
    >
      {!item.active ? (
        <Link
          to={item.link}
          className="text-decoration-none text-primary d-flex align-items-center gap-2"
          style={{ lineHeight: "1.5" }}
        >
          {item.icon && <i className={`${item.icon} fs-6`}></i>}
          <span>{item.label}</span>
        </Link>
      ) : (
        <span
          className="d-flex align-items-center gap-2 text-secondary"
          style={{ lineHeight: "1.5" }}
        >
          {item.icon && <i className={`${item.icon} fs-6`}></i>}
          <span>{item.label}</span>
        </span>
      )}
    </Breadcrumb.Item>
  ))}
</Breadcrumb>
  );
};

export default BreadCrumb;
